export const languages = {
  en: {
    code: 'en',
    // Interface ("chrome") strings used outside page content — skip link,
    // breadcrumb, header controls, pagination, collection headers (WCAG 3.1.2:
    // Welsh pages must not speak English UI text with a Welsh voice).
    ui: {
      skipToContent: 'Skip to main content',
      youAreHere: 'You are here:',
      breadcrumb: 'Breadcrumb',
      mainNav: 'Main',
      footerNav: 'Footer',
      accessibilitySettings: 'Accessibility settings',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      pagination: 'Pagination',
      previousPage: 'Previous page',
      nextPage: 'Next page',
      pageN: (n) => `Page ${n}`,
      pageOf: (p, t) => `Page ${p} of ${t}`,
      backTo: (label) => `Back to ${label}`,
      collectionNo: (id) => `Collection #${id}`,
      collection: 'Collection',
      partOf: (name) => `part of ${name}`,
      subsections: (n) => `${n} ${n === 1 ? 'subsection' : 'subsections'}`,
      subsectionWord: (n) => (n === 1 ? 'subsection' : 'subsections'),
      websiteWord: (n) => (n === 1 ? 'website' : 'websites'),
      // Visible cue at the foot of a collection card (the card itself is the link).
      cardBrowse: 'Browse',
      cardViewWebsites: 'View websites',
      newTab: '(opens in a new tab)',
      changeLanguage: 'Change the website language',
      urlInvalid: 'Enter a valid web address, for example bl.uk or https://www.bl.uk',
      errorPrefix: 'Error:',
    },
    name: 'English',
    urlPrefix: '/en',
    siteTitle: 'UK Web Archive',
    description: 'Preserving the UK Web for future generations',
    homeLabel: 'Home',
    menu: [
      { name: 'Home', path: '/en', slug: '' },
      { name: 'Collections and Themes', path: '/en/ukwa/collection', slug: 'themes' },
      { name: 'Save a UK Website', path: '/en/ukwa/info/nominate', slug: 'save-website' },
      { name: 'About Us', path: '/en/about', slug: 'about' },
      { name: 'Contact Us', path: '/en/contact', slug: 'contact' },
    ],
    information: {
      label: 'Information',
      path: '/en/ukwa/info',
      pages: [
        { name: 'About Us', path: '/en/about', slug: 'about' },
        { name: 'FAQ', path: '/en/ukwa/info/faq', slug: 'information/faq' },
        { name: 'Cookie Policy', path: 'https://join-britishlibrary.co.uk/cookie-policy/', isExternal: true },
        { name: 'Accessibility Statement', path: '/en/ukwa/info/accessibility', slug: 'information/accessibility' },
        { name: 'Terms and Conditions', path: '/en/ukwa/info/terms', slug: 'information/terms' },
        { name: 'Technical Information', path: '/en/ukwa/info/technical-information', slug: 'information/technical-information' },
        { name: 'Notice and Takedown', path: '/en/ukwa/info/notice-and-takedown', slug: 'information/notice-and-takedown' },
        { name: 'Sitemap', path: '/en/ukwa/info/sitemap', slug: 'information/sitemap' },
      ],
    },
  },
  cy: {
    code: 'cy',
    // Welsh interface strings — pending review by the BL Welsh translator.
    ui: {
      skipToContent: "Neidio i'r prif gynnwys",
      youAreHere: 'Rydych chi yma:',
      breadcrumb: 'Briwsion bara',
      mainNav: 'Prif',
      footerNav: 'Troedyn',
      accessibilitySettings: 'Gosodiadau hygyrchedd',
      openMenu: 'Agor y ddewislen',
      closeMenu: "Cau'r ddewislen",
      pagination: 'Tudalennu',
      previousPage: 'Tudalen flaenorol',
      nextPage: 'Tudalen nesaf',
      pageN: (n) => `Tudalen ${n}`,
      pageOf: (p, t) => `Tudalen ${p} o ${t}`,
      backTo: (label) => `Yn ôl i ${label}`,
      collectionNo: (id) => `Casgliad #${id}`,
      collection: 'Casgliad',
      partOf: (name) => `rhan o ${name}`,
      // Welsh uses the singular noun after a numeral: "13 is-adran".
      subsections: (n) => `${n} is-adran`,
      subsectionWord: () => 'is-adran',
      websiteWord: () => 'gwefan',
      cardBrowse: 'Pori',
      cardViewWebsites: 'Gweld gwefannau',
      newTab: '(yn agor mewn tab newydd)',
      changeLanguage: 'Newid iaith y wefan', // pending review
      urlInvalid: 'Rhowch gyfeiriad gwe dilys, er enghraifft bl.uk neu https://www.bl.uk',
      errorPrefix: 'Gwall:',
    },
    name: 'Cymraeg',
    urlPrefix: '/cy',
    siteTitle: 'Archif We y DU',
    description: "Cadw'r We yn y DU ar gyfer cenedlaethau'r dyfodol",
    homeLabel: 'Hafan',
    menu: [
      { name: 'Hafan', path: '/cy', slug: '' },
      { name: 'Them\u00e2u', path: '/cy/ukwa/collection', slug: 'themes' },
      { name: 'Cadw Gwefan y DU', path: '/cy/ukwa/info/nominate', slug: 'save-website' },
      { name: 'Amdanom Ni', path: '/cy/about', slug: 'about' },
      { name: 'Cysylltwch \u00e2 Ni', path: '/cy/contact', slug: 'contact' },
    ],
    information: {
      label: 'Gwybodaeth',
      path: '/cy/ukwa/info',
      pages: [
        { name: 'Amdanom Ni', path: '/cy/about', slug: 'about' },
        { name: 'Cwestiynau Cyffredin', path: '/cy/ukwa/info/faq', slug: 'information/faq' },
        { name: 'Polisi Cwcis', path: 'https://join-britishlibrary.co.uk/cookie-policy/', isExternal: true },
        { name: 'Datganiad Hygyrchedd', path: '/cy/ukwa/info/accessibility', slug: 'information/accessibility' },
        { name: 'Telerau ac Amodau', path: '/cy/ukwa/info/terms', slug: 'information/terms' },
        { name: 'Gwybodaeth Dechnegol', path: '/cy/ukwa/info/technical-information', slug: 'information/technical-information' },
        { name: 'Hysbysiad a Dileu', path: '/cy/ukwa/info/notice-and-takedown', slug: 'information/notice-and-takedown' },
        { name: 'Map y Wefan', path: '/cy/ukwa/info/sitemap', slug: 'information/sitemap' },
      ],
    },
  },
  gd: {
    code: 'gd',
    // Gaelic interface strings — pending review by a Gàidhlig translator.
    ui: {
      skipToContent: "Leum chun a' phrìomh shusbaint",
      youAreHere: 'Tha thu an seo:',
      breadcrumb: 'Slighe',
      mainNav: 'Prìomh',
      footerNav: 'Bonn-duilleige',
      accessibilitySettings: 'Roghainnean so-ruigsinneachd',
      openMenu: 'Fosgail an clàr-taice',
      closeMenu: 'Dùin an clàr-taice',
      pagination: 'Duilleagan',
      previousPage: 'An duilleag roimhe',
      nextPage: 'An ath dhuilleag',
      pageN: (n) => `Duilleag ${n}`,
      pageOf: (p, t) => `Duilleag ${p} de ${t}`,
      backTo: (label) => `Air ais gu ${label}`,
      collectionNo: (id) => `Cruinneachadh #${id}`,
      collection: 'Cruinneachadh',
      partOf: (name) => `pàirt de ${name}`,
      subsections: (n) => `${n} fo-earrannan`,
      subsectionWord: () => 'fo-earrannan',
      websiteWord: () => 'làraichean-lìn',
      cardBrowse: 'Brabhsaich',
      cardViewWebsites: 'Seall làraichean-lìn',
      newTab: '(fosglaidh seo ann an taba ùr)',
      changeLanguage: 'Atharraich cànan na làraich-lìn', // pending review
      urlInvalid: 'Cuir a-steach seòladh-lìn dligheach, mar eisimpleir bl.uk no https://www.bl.uk',
      errorPrefix: 'Mearachd:',
    },
    name: 'G\u00e0idhlig',
    urlPrefix: '/gd',
    siteTitle: 'Tasglann L\u00ecn na RA',
    description: "A' gleidheadh L\u00econ na RA airson ginealaich ri teachd",
    homeLabel: 'Dachaigh',
    menu: [
      { name: 'Dachaigh', path: '/gd', slug: '' },
      { name: 'Cuspairean', path: '/gd/ukwa/collection', slug: 'themes' },
      { name: 'S\u00e0bhail L\u00e0rach-l\u00ecn na RA', path: '/gd/ukwa/info/nominate', slug: 'save-website' },
      { name: 'Mu ar Deidhinn', path: '/gd/about', slug: 'about' },
      { name: 'Cuir Fios Thugainn', path: '/gd/contact', slug: 'contact' },
    ],
    information: {
      label: 'Fiosrachadh',
      path: '/gd/ukwa/info',
      pages: [
        { name: 'Mu ar Deidhinn', path: '/gd/about', slug: 'about' },
        { name: 'Ceistean Cumanta', path: '/gd/ukwa/info/faq', slug: 'information/faq' },
        { name: 'Poileasaidh Briosgaidean', path: 'https://join-britishlibrary.co.uk/cookie-policy/', isExternal: true },
        // Gaelic statement hidden until its translation is approved: link to the English one, and say so.
        { name: 'Aithris In-ruigsinneachd (Beurla)', path: '/en/ukwa/info/accessibility', slug: 'information/accessibility' },
        { name: 'Teirmichean is Cumhaichean', path: '/gd/ukwa/info/terms', slug: 'information/terms' },
        { name: 'Fiosrachadh Teicnigeach', path: '/gd/ukwa/info/technical-information', slug: 'information/technical-information' },
        { name: 'Fios is Toirt air Falbh', path: '/gd/ukwa/info/notice-and-takedown', slug: 'information/notice-and-takedown' },
        { name: 'Mapa na Làraich', path: '/gd/ukwa/info/sitemap', slug: 'information/sitemap' },
      ],
    },
  },
};

export const defaultLanguage = 'en';
// NOTE: 'gd' (Gàidhlig) is temporarily hidden — removing it from languageOrder
// drops every visible Gàidhlig link (language switcher, sitemap) while the `gd`
// config and its /gd routes remain intact and reachable by direct URL. To
// restore, add 'gd' back to this array.
export const languageOrder = ['en', 'cy'];

// ─── Collections routing ───────────────────────────────────────────────────────
// Collections live under an explicit, locale-prefixed namespace that is uniform
// across every language:
//
//     /{lang}/ukwa/collection           → index (all themes)
//     /{lang}/ukwa/collection/{id}      → a single collection
//
// Like every page on the site, English carries an explicit `/en` here (its
// urlPrefix), so the locale is always the first path segment. These helpers are
// the single source of truth for building collection paths — use them instead
// of string-concatenating the prefix anywhere a collection link is produced.
export const collectionsBase = (langCode) => `/${langCode}/ukwa/collection`;
export const collectionPath = (langCode, id) =>
  id == null ? collectionsBase(langCode) : `${collectionsBase(langCode)}/${id}`;
